module.exports = __webpack_public_path__ + "static/media/slider04.d0c01e1c.png";